// Helper to register Angular custom element in the DOM
export const registerMockAngularMfe = () => {
  if (typeof window !== 'undefined' && !customElements.get('angular-investing-mfe')) {
    class AngularPortfolioMfe extends HTMLElement {
      private _title = 'Angular MFE';
      
      static get observedAttributes() {
        return ['title'];
      }

      attributeChangedCallback(name: string, _oldValue: string, newValue: string) {
        if (name === 'title') {
          this._title = newValue;
          this.render();
        }
      }

      connectedCallback() {
        this.render();
      }

      render() {
        this.innerHTML = `
          <div style="background: linear-gradient(135deg, #1e1b4b, #311042); border: 2px solid #ec4899; padding: 24px; border-radius: 12px; box-shadow: 0 4px 20px rgba(236, 72, 153, 0.2)">
            <h3 style="color: #ec4899; margin-bottom: 12px; font-family: sans-serif;">🛡️ ${this._title}</h3>
            <p style="color: #cbd5e1; font-size: 14px; line-height: 1.5">
              This micro frontend is rendered as a <strong>Native Web Component</strong> (Custom Element), simulating an Angular 19 compilation mapping.
            </p>
            <div style="margin-top: 16px; display: grid; grid-template-columns: repeat(3, 1fr); gap: 10px;">
              <div style="background: rgba(255,255,255,0.05); padding: 10px; border-radius: 6px; text-align: center;">
                <span style="font-size: 12px; color: #94a3b8">Active Assets</span>
                <div style="font-weight: bold; color: #fff; margin-top: 4px;">AAPL, TSLA</div>
              </div>
              <div style="background: rgba(255,255,255,0.05); padding: 10px; border-radius: 6px; text-align: center;">
                <span style="font-size: 12px; color: #94a3b8">ROI</span>
                <div style="font-weight: bold; color: #4ade80; margin-top: 4px;">+24.8%</div>
              </div>
              <div style="background: rgba(255,255,255,0.05); padding: 10px; border-radius: 6px; text-align: center;">
                <span style="font-size: 12px; color: #94a3b8">Risk Factor</span>
                <div style="font-weight: bold; color: #fbbf24; margin-top: 4px;">Medium</div>
              </div>
            </div>
          </div>
        `;
      }
    }
    customElements.define('angular-investing-mfe', AngularPortfolioMfe);
  }
};

// Helper to register Vue bootstrap functions in window context
export const registerMockVueMfe = () => {
  if (typeof window !== 'undefined') {
    const win = window as any;
    win.mountVueSettingsMfe = (container: HTMLElement, props: any) => {
      container.innerHTML = `
        <div style="background: linear-gradient(135deg, #064e3b, #022c22); border: 2px solid #10b981; padding: 24px; border-radius: 12px; box-shadow: 0 4px 20px rgba(16, 185, 129, 0.2)">
          <h3 style="color: #10b981; margin-bottom: 12px; font-family: sans-serif;">⚡ Vue Settings MFE</h3>
          <p style="color: #cbd5e1; font-size: 14px;">
            Bootstrapped via a <strong>Global mount function</strong> matching standard Vue/Single-SPA lifecycles.
          </p>
          <div style="margin-top: 12px;">
            <span style="font-size: 13px; color: #a7f3d0">Target Currency: <strong>${props.currency || 'USD'}</strong></span>
          </div>
          <div style="margin-top: 10px; font-size: 13px; color: #a7f3d0">
            Notification Mode: <strong>SMS & Email</strong>
          </div>
        </div>
      `;
    };
    win.unmountVueSettingsMfe = (container: HTMLElement) => {
      container.innerHTML = '';
    };
  }
};
